import { useTranslation } from 'react-i18next'

import { nanoid } from 'nanoid'

import EmptyImage from 'shared/images/empty-image.webp'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  images: { src: string }[]
  title: string
  onClickImage: (index: number) => void
}

export const Gallery = ({ images, title, onClickImage }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={s.grid}>
      {images?.map((item, index) => (
        <div
          className={s.imageWrapper}
          key={nanoid()}
          onClick={() => onClickImage(index)}
        >
          <ImageLazy
            src={item.src}
            alt={t('tours_block.image_alt', {
              count: index + 1,
              hotelName: title,
            })}
            errorImage={EmptyImage}
            className={s.image}
          />
        </div>
      ))}
    </div>
  )
}
